import { Seq, Set } from 'immutable';
import { UserRole } from 'src/graphql/generated/graphql.generated';

export function flatMapUserRoles(withUserRoles: Seq.Indexed<{ userRoles?: Set<UserRole> | null }>) {
  const roles = withUserRoles
    .filter((_) => _.userRoles != null)
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .flatMap((u) => u.userRoles!)
    .toSet();
  return roles;
}
